"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.propTypes = void 0;

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypes2 = require("@decisiv/prop-types");

var _commonUIColors = require("../../utils/commonUIColors");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  'aria-label': (0, _propTypes2.requireIf)(_propTypes.default.string, function (_ref) {
    var text = _ref.text;
    return (0, _isEmpty.default)(text);
  }),
  contentProps: (0, _propTypes2.requireAtLeastOneOf)({
    text: _propTypes.default.string,
    icon: _propTypes.default.elementType
  }),
  actionProps: (0, _propTypes2.requireAllOrNoneOf)({
    action: _propTypes.default.func,
    actionIcon: _propTypes.default.elementType
  }),
  ifActionRequireText: (0, _propTypes2.requireIfDefined)('action', {
    text: _propTypes.default.string
  }),
  actionAttributes: (0, _propTypes2.requireIf)(_propTypes.default.shape({
    'aria-label': _propTypes.default.string.isRequired
  }), function (_ref2) {
    var action = _ref2.action;
    return Boolean(action);
  }),
  actionIntent: _propTypes.default.oneOf(['normal', 'danger']),
  actionRef: _propTypes.default.any,
  color: _propTypes.default.oneOf(_commonUIColors.commonUIColorKeys),
  variant: _propTypes.default.oneOf(['normal', 'outline']),
  palette: _propTypes.default.oneOf(['pastel', 'bright', 'dark']),
  size: _propTypes.default.oneOf(['small', 'medium'])
};
exports.propTypes = propTypes;
var defaultProps = {
  action: undefined,
  actionAttributes: undefined,
  actionIcon: undefined,
  actionIntent: 'normal',
  actionRef: undefined,
  color: undefined,
  icon: undefined,
  text: undefined,
  variant: 'normal',
  palette: 'bright'
};
exports.defaultProps = defaultProps;